module.exports = __webpack_public_path__ + "assets/img/be-member-alert.4c0d6e4d.png";